import { FC } from "react"
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card"
import { Droplets } from "lucide-react"
import { TableDateDisplay } from "./ui/date-display"

interface MeterReadingProps {
  current: number
  lastRead: string
  unit?: string
}

const MeterReading: FC<MeterReadingProps> = ({ current, lastRead, unit }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Droplets className="size-5" />
          Meter Reading
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="text-center">
          <p className="text-sm text-muted-foreground">Current Reading</p>
          <p className="text-3xl font-bold text-primary">
            {current}
            {unit}
          </p>
        </div>

        <div className="text-center">
          <p className="text-sm text-muted-foreground">Last Index Read</p>
          <p className="font-medium">
            <TableDateDisplay date={lastRead} />
          </p>
        </div>
      </CardContent>
    </Card>
  )
}

export default MeterReading
